/* Pinned products first in the collection grid, in the listed order (ad links):
     ?pin=<product id or handle>,...     short form; product IDs recommended (stable when a handle changes)
     ?pin_product=<handle>,...           original form, still supported
   Links are built with the pin-link builder: /collections/<handle>?view=pin-builder.
   The reorder itself is inline in snippets/pin-product-inline.liquid, right after the grid, so the first paint is
   already pinned. When every pinned product is already on page 1 that is all that happens (no extra request).
   When a pinned product sits further down the collection (or is given by an ID not on this page), this file makes
   the whole list read as "pinned products, then everything else in its usual order", same number per page:
   - it reads the collection order once (sections/pin-product-order.liquid: id:handle, same sort and filters),
   - works out which products the current page should show,
   - fetches cards it does not have (sections/pin-product-card.liquid): the pinned product on page 1, and on later
     pages the products pushed over from the previous page,
   - hides the rest; pagination links carry ?pin (as IDs) so every page follows the same order.
   Filter / sort keep the pin (hidden form fields; facets.js calls pinProductToTop after each re-render).
   Result record for every view: window.ptPin.last, document event 'pt:pin-product', Shopify customer event
   'pin_product_result' (reason per item that could not be pinned). Add ?pin_debug=1 to log it.
   Any failure leaves the page as the inline step arranged it. */
(function () {
  var P = window.ptPin;
  if (!P || !P.apply || P.enhanced) return;
  P.enhanced = true;

  var MAX_ORDER_PAGES = 4; // 4 x 250 products
  var cards = {}; // handle -> Promise<{li} | {reason}>
  var orders = {}; // order-list URL -> Promise<{list, complete} | null>
  var idOf = {}; // handle -> product id
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PARAMS = ['pin', 'pin_product'];

  function grid() {
    return document.getElementById('product-grid');
  }

  function param(name) {
    return (P.params() && P.params().get(name)) || '';
  }

  function filtered() {
    var q = P.params();
    var on = false;
    if (q) q.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 && v) on = true;
    });
    return on;
  }

  function learnIds(g) {
    for (var i = 0; i < g.children.length; i++) {
      var li = g.children[i];
      var card = li.querySelector('[data-product-handle]');
      var id = li.getAttribute('data-product-id');
      if (card && id) idOf[card.getAttribute('data-product-handle').toLowerCase()] = id;
    }
  }

  function timed(url, ms) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
    }, ms);
    return fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined }).then(
      function (r) {
        clearTimeout(timer);
        return r;
      },
      function (e) {
        clearTimeout(timer);
        throw e;
      }
    );
  }

  function loadCard(handle) {
    return timed(root + 'products/' + encodeURIComponent(handle) + '?section_id=pin-product-card', 8000)
      .then(function (r) {
        if (r.status === 404) return { reason: 'not_found' };
        if (!r.ok) return { reason: 'http_' + r.status };
        return r.text().then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var box = tmp.querySelector('[data-pin-card]');
          if (!box || !box.getAttribute('data-handle')) return { reason: 'not_found' };
          var li = document.createElement('li');
          li.className = 'grid__item';
          li.setAttribute('data-pin-fetched', '');
          if (box.getAttribute('data-id')) li.setAttribute('data-product-id', box.getAttribute('data-id'));
          while (box.firstChild) li.appendChild(box.firstChild);
          return { li: li };
        });
      })
      .catch(function (e) {
        return { reason: e && e.name === 'AbortError' ? 'timeout' : 'network' };
      });
  }

  function fetchCard(handle) {
    if (cards[handle]) return cards[handle];
    cards[handle] = loadCard(handle)
      .then(function (res) {
        // One retry for a slow or dropped request; a real answer (404, 429, ...) is not retried.
        return res.reason === 'timeout' || res.reason === 'network' || /^http_5/.test(res.reason || '') ? loadCard(handle) : res;
      })
      .then(function (res) {
        if (!res.li) delete cards[handle]; // allow a retry on the next re-render
        return res;
      });
    return cards[handle];
  }

  // Collection order under the current sort and filters, read 250 at a time until it covers what is needed:
  // every pinned token found (as handle or id) and at least `upTo` products, or the end of the collection.
  function fetchOrder(tokens, upTo) {
    var q = P.params() || new URLSearchParams();
    var base = new URLSearchParams();
    q.forEach(function (v, k) {
      if (k !== 'page' && PARAMS.indexOf(k) === -1 && k !== 'pin_debug' && k !== 'section_id' && k !== 'view') base.append(k, v);
    });
    base.set('section_id', 'pin-product-order');
    var key = window.location.pathname + '?' + base.toString() + '#' + tokens.join(',') + '#' + upTo;
    if (orders[key]) return orders[key];
    var list = [];
    var ids = {};
    function found(t) {
      return P.isId(t) ? !!ids[t] : list.indexOf(t) > -1;
    }
    function enough() {
      return list.length >= upTo && tokens.every(found);
    }
    function page(n) {
      base.set('page', n);
      return timed(window.location.pathname + '?' + base.toString(), 8000)
        .then(function (r) {
          if (!r.ok) throw new Error('http_' + r.status);
          return r.text();
        })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var box = tmp.querySelector('[data-pin-order]');
          if (!box) throw new Error('no_order');
          var text = (box.textContent || '').trim();
          if (text) text.split(',').forEach(function (entry) {
            var at = entry.indexOf(':');
            var h = (at > -1 ? entry.slice(at + 1) : entry).trim().toLowerCase();
            if (at > -1) {
              var id = entry.slice(0, at).trim();
              ids[id] = h;
              P.ids[id] = h;
              idOf[h] = id;
            }
            list.push(h);
          });
          var pages = parseInt(box.getAttribute('data-pages'), 10) || 1;
          if (n >= pages) return { list: list, complete: true };
          if (enough() || n >= MAX_ORDER_PAGES) return { list: list, complete: false };
          return page(n + 1);
        });
    }
    orders[key] = page(1).catch(function () {
      delete orders[key];
      return null;
    });
    return orders[key];
  }

  // Show exactly `slice` (handles, in order) in the grid; everything else in it is hidden.
  function arrange(g, slice, pinned, extra) {
    var items = P.items(g);
    var k;
    for (k in extra) if (!items[k]) items[k] = extra[k];
    var want = {};
    slice.forEach(function (h) {
      want[h] = true;
    });
    for (k in items) {
      if (!want[k]) {
        items[k].hidden = true;
        items[k].removeAttribute('data-pinned');
      }
    }
    for (var i = slice.length - 1; i >= 0; i--) {
      var li = items[slice[i]];
      if (!li) continue;
      li.hidden = false;
      g.insertBefore(li, g.firstChild);
      if (pinned.indexOf(slice[i]) > -1) {
        li.setAttribute('data-pinned', '');
        li.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.setAttribute('loading', 'eager');
        });
      }
    }
    var n = 0;
    for (var m = 0; m < g.children.length; m++) if (!g.children[m].hidden) g.children[m].style.setProperty('--animation-order', ++n);
  }

  // Pagination keeps the pin only when it changes what later pages show, and carries the pins page 1 actually
  // used (as product IDs where known), so every page follows the same order.
  function pagination(keep, pins) {
    var value = pins ? pins.map(function (h) {
      return idOf[h] || h;
    }).join(',') : P.tokens().join(',');
    document.querySelectorAll('#ProductGridContainer .pagination a[href]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.href);
        u.searchParams.delete('pin_product');
        if (keep && value) u.searchParams.set('pin', value);
        else u.searchParams.delete('pin');
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }

  // Mirror ?pin / ?pin_product into the filter/sort forms so a re-render keeps them in the URL.
  function addPinProductToForms() {
    PARAMS.forEach(function (name) {
      var value = param(name);
      if (!value) return;
      document.querySelectorAll('facet-filters-form form').forEach(function (form) {
        var input = form.querySelector('input[name="' + name + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = value;
      });
    });
  }

  function report(result) {
    P.last = result;
    try {
      document.dispatchEvent(new CustomEvent('pt:pin-product', { detail: result }));
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('pin_product_result', result);
      }
    } catch (e) {}
    try {
      if (P.params().get('pin_debug') === '1') console.info('[pin_product]', result);
    } catch (e) {}
  }

  var run = 0;
  function pinProductToTop() {
    var g = grid();
    addPinProductToForms();
    if (!g) return;
    var mine = ++run;
    var base = P.apply();
    var tokens = base.tokens;
    if (!tokens.length) return;
    learnIds(g);
    var perPage = parseInt(g.getAttribute('data-per-page'), 10) || g.children.length || 16;
    var page = base.page;
    var result = {
      collection: g.getAttribute('data-collection-handle') || '',
      requested: tokens,
      page: page,
      sort: param('sort_by'),
      pinned: [],
      fetched: [],
      missing: [],
    };
    var absent = base.handles.filter(function (h) {
      return base.onPage.indexOf(h) === -1;
    });
    if (page === 1 && !absent.length) {
      // Everything pinned was already on page 1: the inline step has done it all, later pages are unaffected.
      pagination(false);
      result.pinned = base.placed;
      report(result);
      return;
    }
    pagination(true);
    // Page 1: start the missing pinned cards (given by handle) together with the order list (cached, reused below).
    if (page === 1) absent.forEach(function (h) {
      if (!P.isId(h)) fetchCard(h);
    });
    fetchOrder(tokens, perPage * page)
      .then(function (order) {
        if (mine !== run || grid() !== g) return null;
        if (!order) {
          // Could not read the order: keep the inline arrangement; on page 2+ the repeats stay hidden.
          result.pinned = page === 1 ? base.placed : [];
          absent.forEach(function (h) {
            result.missing.push({ item: h, reason: 'order_unavailable' });
          });
          return result;
        }
        var list = order.list;
        var handles = tokens.map(P.handleOf);
        var inList = [];
        handles.forEach(function (h) {
          if (list.indexOf(h) > -1 && inList.indexOf(h) === -1) inList.push(h);
        });
        var notListed = handles.filter(function (h) {
          return list.indexOf(h) === -1;
        });
        var present = P.items(g);
        function sliceFor(pins) {
          var rest = list.filter(function (h) {
            return pins.indexOf(h) === -1;
          });
          return pins.concat(rest).slice(perPage * (page - 1), perPage * page);
        }
        var slice = sliceFor(inList);
        var need = slice.filter(function (h) {
          return !present[h];
        });
        // Not in this list: a handle can still be looked up to tell "no such product" from "not in this collection".
        var lookups = notListed.filter(function (h) {
          return !P.isId(h);
        });
        notListed.forEach(function (h) {
          if (!P.isId(h)) return;
          result.missing.push({ item: h, reason: filtered() ? 'filtered_out_or_unknown' : order.complete ? 'not_in_collection_or_unknown' : 'beyond_limit' });
        });
        return Promise.all(need.concat(lookups).map(function (h) {
          return fetchCard(h).then(function (res) {
            return { handle: h, res: res };
          });
        })).then(function (got) {
          if (mine !== run || grid() !== g) return null;
          var extra = {};
          var failed = [];
          got.forEach(function (x) {
            var listed = lookups.indexOf(x.handle) === -1;
            if (listed && x.res.li) {
              // Clone: a later sort re-render can reuse the cached card.
              extra[x.handle] = x.res.li.cloneNode(true);
              if (inList.indexOf(x.handle) > -1) result.fetched.push(x.handle);
            } else if (!listed) {
              var why = x.res.reason || (filtered() ? 'filtered_out' : order.complete ? 'not_in_collection' : 'beyond_limit');
              result.missing.push({ item: x.handle, reason: why });
            } else {
              failed.push(x.handle);
              result.missing.push({ item: x.handle, reason: 'card_' + x.res.reason });
            }
          });
          var have = function (h) {
            return present[h] || extra[h];
          };
          var pins = inList;
          if (failed.length) {
            if (page > 1) return result; // keep the inline arrangement (repeats hidden) rather than leave a gap
            // Page 1: a pinned card that could not be loaded is simply not pinned; the page stays full.
            pins = inList.filter(function (h) {
              return failed.indexOf(h) === -1;
            });
            slice = sliceFor(pins);
            if (!slice.every(have)) return result;
          }
          arrange(g, slice, pins, extra);
          if (page === 1) pagination(pins.some(function (h) {
            return !present[h];
          }), pins);
          result.pinned = page === 1 ? pins.filter(have) : [];
          return result;
        });
      })
      .then(function (res) {
        if (res) report(res);
      });
  }

  window.pinProductToTop = pinProductToTop; // facets.js calls this after every filter / sort re-render
  window.addPinProductToForms = addPinProductToForms;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pinProductToTop);
  else pinProductToTop();
})();
